import React from 'react';
import { Helmet } from 'react-helmet';

function About() {
  const teamMembers = [
    {
      id: 1,
      name: "Sarah Mitchell",
      role: "Founder and Chief Executive Officer",
      bio: "With over 20 years in landscape design, Sarah founded Tanarela to bring premium natural stone products to Australian homeowners and designers.",
      image: "/images/team_1.jpg"
    },
    {
      id: 2,
      name: "Emma Richardson",
      role: "Head of Product Selection",
      bio: "Emma travels Australia sourcing the finest natural stones, ensuring every product meets our exacting standards for quality and beauty.",
      image: "/images/team_2.jpg"
    },
    {
      id: 3,
      name: "Marcus Thompson",
      role: "Landscape Design Consultant",
      bio: "Marcus brings 15 years of landscape architecture experience, helping customers create stunning outdoor spaces with our stone products.",
      image: "/images/team_3.jpg"
    },
    {
      id: 4,
      name: "Olivia Chen",
      role: "Customer Experience Director",
      bio: "Olivia ensures every customer receives exceptional service, from initial consultation through delivery and installation support.",
      image: "/images/team_4.jpg"
    },
    {
      id: 5,
      name: "Daniel Fraser",
      role: "Sustainability Coordinator",
      bio: "Daniel oversees our environmental initiatives, working with quarries to ensure responsible sourcing and sustainable business practices.",
      image: "/images/team_5.jpg"
    }
  ];

  return (
    <>
      <Helmet>
        <title>About Tanarela - Our Story and Team</title>
        <meta name="description" content="Learn about Tanarela, our commitment to premium landscape design materials, and meet the team dedicated to transforming outdoor spaces across Australia." />
        <meta property="og:title" content="About Tanarela - Premium Landscape Materials" />
        <link rel="canonical" href="https://tanarela.com/about" />
      </Helmet>

      <section className="about-section">
        <div className="about-container">
          <h1>About Tanarela</h1>
          
          <div className="about-intro">
            <p>
              Tanarela was born from a passion for natural beauty and exceptional outdoor design. 
              Founded in 2010, we have grown to become one of Australia leading suppliers of premium 
              natural stone products for landscape design, serving homeowners, landscapers, and architects 
              who demand the very best materials for their outdoor projects.
            </p>
            <p>
              Our journey began with a simple belief: that every outdoor space deserves the timeless 
              elegance and durability that only natural stone can provide. Today, we continue to source 
              the finest sandstone, granite, limestone, and river stones from across Australia, bringing 
              nature most beautiful creations to gardens, pathways, and outdoor living areas nationwide.
            </p>
          </div>

          <div className="mission-vision">
            <div className="mission-box">
              <h2>Our Mission</h2>
              <p>
                To provide Australian homeowners and design professionals with exceptional natural stone 
                products that combine timeless beauty, superior quality, and environmental responsibility. 
                We are committed to sourcing materials sustainably, delivering outstanding customer service, 
                and inspiring the creation of outdoor spaces that connect people with nature beauty.
              </p>
            </div>

            <div className="vision-box">
              <h2>Our Vision</h2>
              <p>
                To be recognized as Australia most trusted provider of premium landscape stone products, 
                known for our unwavering commitment to quality, sustainability, and customer satisfaction. 
                We envision a future where every outdoor space is enhanced by natural materials sourced 
                responsibly and selected with care, creating lasting beauty for generations to come.
              </p>
            </div>
          </div>

          <div className="team-section">
            <h2>Meet Our Expert Team</h2>
            <div className="team-grid">
              {teamMembers.map(member => (
                <div key={member.id} className="team-card">
                  <div className="team-image-container">
                    <img 
                      src={member.image} 
                      width="400" 
                      height="400" 
                      alt={`Team member ${member.id}`} 
                      className="team-image"
                    />
                  </div>
                  <div className="team-info">
                    <h3>{member.name}</h3>
                    <p className="team-role">{member.role}</p>
                    <p className="team-bio">{member.bio}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="values-section">
            <h2>Our Core Values</h2>
            <div className="values-grid">
              <div className="value-item">
                <h3>Quality Excellence</h3>
                <p>
                  We never compromise on quality. Every product is carefully selected and inspected 
                  to ensure it meets our exacting standards for durability and beauty.
                </p>
              </div>

              <div className="value-item">
                <h3>Environmental Stewardship</h3>
                <p>
                  Sustainability is at the heart of everything we do. We work exclusively with 
                  quarries that practice responsible environmental management.
                </p>
              </div>

              <div className="value-item">
                <h3>Customer Partnership</h3>
                <p>
                  We build lasting relationships with our customers, providing expert guidance 
                  and support throughout every project, large or small.
                </p>
              </div>

              <div className="value-item">
                <h3>Innovation and Design</h3>
                <p>
                  We stay at the forefront of landscape design trends, continuously expanding 
                  our collection to inspire creative outdoor spaces.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default About;